.#{$namespace}-dropdown {
	display: inline-flex;
	align-items: center;
	vertical-align: middle;

	&__link {
		display: inline-flex;
		align-items: center;
		outline: none;
		cursor: pointer;
	}

	&.is-disabled {
		cursor: not-allowed;

		.#{$namespace}-dropdown__link {
			cursor: not-allowed;
			color: $text-disabled-color;
		}
	}
}
